import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { TaxIdRef } from './refs';
import { TaxIdResource } from './resources';
import { CreateTaxIdInput, SyncTaxIdInput, TaxIdFilterInput } from './inputs';

export default class TaxId {
    private basePath = '/api/tax-id';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get TaxID list belonging to payment account
    get = async (filter: TaxIdFilterInput): Promise<CollectionResource<TaxIdResource, {}>> => {
        const query = qs.stringify(filter);

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Sync TaxID
    sync = async (input: SyncTaxIdInput): Promise<TaxIdRef> => {
        const { data } = await this.http.post(`${this.basePath}/sync`, input);

        return data;
    };

    // Create TaxID
    create = async (input: CreateTaxIdInput): Promise<TaxIdRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Remove TaxID
    remove = async (id: ID): Promise<TaxIdRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };
}
